import { ChangeDetectionStrategy, Component, ViewEncapsulation, Input } from '@angular/core';
import { FiWrapperTableAdditionalColumns } from '@fi-shared/fi-wrapper-table/fi-wrapper-table-additional-columns';

@Component({
    selector: 'fi-checklist2-answer-checkpoint',
    template: `
        <ng-container matColumnDef="CheckpointName">
          <mat-header-cell *matHeaderCellDef mat-sort-header #headerCell [hidden]="isHidden">
            <fi-wrapper-table-custom-sort-icon
              sortIconType="string"
              [ariaSortAttribute]="headerCell._getAriaSortAttribute()"
              [headerLabel]="'checklist.checkpoints'"
              >
            </fi-wrapper-table-custom-sort-icon>
          </mat-header-cell>
          <mat-cell
            *matCellDef="let item"
            [hidden]="isHidden"
            class="column-show-mobile"
            [ngClass]="{ 'fi-cell-multi-row': isCheckpointDescriptionShown && item.CheckpointDescription }"
            >
            <fi-wrapper-table-span-cell [value]="item.CheckpointName" />
        
            @if (isCheckpointDescriptionShown && item.CheckpointDescription) {
              <fi-wrapper-table-rollup-content-cell
                >
                <fi-wrapper-table-html-cell class="fi-cell-additional-text" [value]="item.CheckpointDescription" />
              </fi-wrapper-table-rollup-content-cell>
            }
          </mat-cell>
        </ng-container>
        `,
    styleUrls: ['./fi-checklist2-answer-checkpoint.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-answer-value' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2AnswerCheckpointComponent }],
    standalone: false,
})
export class FiChecklist2AnswerCheckpointComponent extends FiWrapperTableAdditionalColumns {
    @Input() isCheckpointDescriptionShown: boolean;
}
